/**
 * 部门角色
 */

 import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectDepartmentRoleById = (Id) => {
  return get('/api/app/DepartmentRole?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddDepartmentRole = (data) => {
  return post('/api/app/DepartmentRole', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyDepartmentRole = (data) => {
  return put('/api/app/DepartmentRole', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataDepartmentRoleList = (data) => {
  return post('/api/app/DepartmentRole/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteDepartmentRole = (id) => {
  return del('/api/app/DepartmentRole/' + id, {}, {});
}